// accessories products (20 items)
export const productsAccessories = [
  // ==================== ACCESSORIES - ADHESIVES ====================
  {
    id: 68,
    slug: "440-gldstk",
    name: "440-GLDSTK",
    variant: "Adhesive",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "adhesive",
    image: "/Assets/images/accessories/440-GLDSTK/440-GLDSTK.jpg",
    heroImage: "/Assets/images/accessories/440-GLDSTK/440-GLDSTK.jpg",
    gallery: ["/Assets/images/accessories/440-GLDSTK/440-GLDSTK.jpg"],
    productSheetPdf: "/Assets/images/accessories/440-GLDSTK/440-GLDSTK_ACT.pdf",
    description: "Multi-purpose, non-toxic adhesive for indoor flooring and surface applications. Ideal for sheet vinyl, VCT installations, and smooth-backed sheet and roll goods carpeting.",
    features: ["Multi-purpose formulation for versatile use", "Non-toxic and low-odor for indoor environments", "Provides reliable adhesion across common flooring materials"],
    specifications: { application: "Trowel-applied", use: "Indoor only", materials: "Sheet Vinyl, VCT, Roll Goods Carpeting" }
  },
  {
    id: 69,
    slug: "2420-adhesive",
    name: "2420",
    variant: "Adhesive",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "adhesive",
    image: "/Assets/images/accessories/2420/2420.jpg",
    heroImage: "/Assets/images/accessories/2420/2420.jpg",
    gallery: ["/Assets/images/accessories/2420/2420.jpg"],
    productSheetPdf: "/Assets/images/accessories/2420/2420_ACT.pdf",
    description: "Universal white acrylic adhesive with antimicrobial protection for resilient indoor flooring. Perfect for luxury vinyl plank, tile, and bitumen-backed carpet tile.",
    features: ["Acrylic-based formula", "Built-in antimicrobial protection", "Designed for resilient flooring materials", "Clean white finish"],
    specifications: { application: "Trowel-applied", use: "Indoor only", materials: "LVP, LVT, Bitumen-backed Carpet Tile" }
  },
  {
    id: 70,
    slug: "631-1100-adhesive",
    name: "631-1100",
    variant: "Adhesive",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "adhesive",
    image: "/Assets/images/accessories/631-1100/631-1100.jpg",
    heroImage: "/Assets/images/accessories/631-1100/631-1100.jpg",
    gallery: ["/Assets/images/accessories/631-1100/631-1100.jpg"],
    productSheetPdf: "/Assets/images/accessories/631-1100/631-1100_ACT.pdf",
    description: "All-weather, water-based adhesive designed for outdoor carpet installations. Ideal for rubber-backed sheet and roll goods carpeting in weather-exposed areas.",
    features: ["All-weather formulation", "Water-based adhesive system", "Designed for rubber-backed materials"],
    specifications: { application: "Trowel-applied", use: "Outdoor", materials: "Outdoor Carpet, Rubber-backed Roll Goods" }
  },
  {
    id: 71,
    slug: "lock-p799-adhesive",
    name: "Lock P799 I/O Rubber",
    variant: "Adhesive",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "adhesive",
    image: "/Assets/images/accessories/Lock-P799-I-O-Rubber/LockP799_IORubber.png",
    heroImage: "/Assets/images/accessories/Lock-P799-I-O-Rubber/LockP799_IORubber.png",
    gallery: ["/Assets/images/accessories/Lock-P799-I-O-Rubber/LockP799_IORubber.png"],
    productSheetPdf: "/Assets/images/accessories/Lock-P799-I-O-Rubber/Lock-P799-Rubber_ACT.pdf",
    description: "Moisture-cured polyurethane adhesive for high-performance rubber flooring applications. Provides exceptional bond strength for recycled rubber flooring installations.",
    features: ["Moisture-cured polyurethane formula", "Exceptional bond strength for rubber materials", "Durable long-term performance"],
    specifications: { application: "Trowel-applied, Moisture-cured", use: "Indoor", materials: "Recycled Rubber Flooring, Rubber Tiles, Rubber Rolls" }
  },
  // ==================== ACCESSORIES - PRE-DRILLED ALUMINUM FRAMES ====================
  {
    id: 72,
    slug: "threshold-001-frame",
    name: "THRESHOLD-001",
    variant: "Aluminum Frame",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "frame",
    image: "/Assets/images/accessories/THRESHOLD-001/Threshold_001.svg",
    heroImage: "/Assets/images/accessories/THRESHOLD-001/Threshold_001.svg",
    gallery: ["/Assets/images/accessories/THRESHOLD-001/Threshold_001.svg"],
    productSheetPdf: "/Assets/images/accessories/THRESHOLD-001/Threshold-001_PAF.pdf",
    description: "Mill-finished, low-profile pre-drilled aluminum frame designed for clean threshold installations. Creates smooth transitions at threshold edges.",
    features: ["Low-profile design minimizes visibility", "Pre-drilled with 10 holes", "Faster, more consistent installation"],
    specifications: { dimensions: "2.5\" W x 8' L x 0.19\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled, 10 holes", profile: "Low profile" }
  },
  {
    id: 73,
    slug: "ramp-5207-frame",
    name: "RAMP-5207",
    variant: "Aluminum Frame",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "frame",
    image: "/Assets/images/accessories/Ramp-5207/RAMP_5207.svg",
    heroImage: "/Assets/images/accessories/Ramp-5207/RAMP_5207.svg",
    gallery: ["/Assets/images/accessories/Ramp-5207/RAMP_5207.svg"],
    productSheetPdf: "/Assets/images/accessories/Ramp-5207/RAMP-5207_PAF.pdf",
    description: "Mill-finished pre-drilled aluminum ramp frame designed for smooth surface transitions. Reduces trip hazards between different surface heights.",
    features: ["Smooth transition between surface heights", "Reduces trip hazards", "Faster, consistent installation"],
    specifications: { dimensions: "2\" W x 8' L x 0.312\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled, 10 holes", profile: "Ramp profile" }
  },
  {
    id: 74,
    slug: "lvt-1-8-0-frame",
    name: "LVT 1-8-0",
    variant: "Aluminum Frame",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "frame",
    image: "/Assets/images/accessories/LVT_1-8-0/LVT_180.svg",
    heroImage: "/Assets/images/accessories/LVT_1-8-0/LVT_180.svg",
    gallery: ["/Assets/images/accessories/LVT_1-8-0/LVT_180.svg"],
    productSheetPdf: "/Assets/images/accessories/LVT_1-8-0/LVT_1-8-0_PAF.pdf",
    description: "Low-profile pre-drilled aluminum frame designed for LVT flooring applications. Minimal transition height with increased fastening points for stability.",
    features: ["Designed for LVT installations", "Minimal transition height", "Increased fastening points for stability"],
    specifications: { dimensions: "1.5\" W x 8' L x 0.125\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled, 16 holes", profile: "Low profile" }
  },
  {
    id: 75,
    slug: "rlpx-ramp-frame",
    name: "RLPX Ramp",
    variant: "Aluminum Frame",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "frame",
    image: "/Assets/images/accessories/RLPX-Ramp/RLPX.svg",
    heroImage: "/Assets/images/accessories/RLPX-Ramp/RLPX.svg",
    gallery: ["/Assets/images/accessories/RLPX-Ramp/RLPX.svg"],
    productSheetPdf: "/Assets/images/accessories/RLPX-Ramp/RLPX_PAF.pdf",
    description: "Mill-finished pre-drilled aluminum ramp frame for extended-length surface transitions. Ideal for longer transition spans with greater height differences.",
    features: ["Ideal for longer transition spans", "Accommodates greater height differences", "Smooth continuous transition"],
    specifications: { dimensions: "1.56\" W x 12' L x 0.5\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", profile: "Ramp profile" }
  },
  {
    id: 76,
    slug: "overlap-ramp-81611-frame",
    name: "OVERLAP Ramp-81611",
    variant: "Aluminum Frame",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "frame",
    image: "/Assets/images/accessories/OVERLAP-Ramp-81611/RAMP_81611.svg",
    heroImage: "/Assets/images/accessories/OVERLAP-Ramp-81611/RAMP_81611.svg",
    gallery: ["/Assets/images/accessories/OVERLAP-Ramp-81611/RAMP_81611.svg"],
    productSheetPdf: "/Assets/images/accessories/OVERLAP-Ramp-81611/RAMP-81611_PAF.pdf",
    description: "Mill-finished pre-drilled aluminum overlap ramp for secure transitions between surfaces. Creates a secure overlap to bridge uneven edges.",
    features: ["Creates a secure overlap between adjoining surfaces", "Helps bridge uneven edges", "Faster, consistent installation"],
    specifications: { dimensions: "2.75\" W x 8' L x 0.457\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled, 10 holes", profile: "Overlap ramp profile" }
  },
  {
    id: 77,
    slug: "smf-17-frame",
    name: "SMF-17",
    variant: "Aluminum Frame",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "frame",
    image: "/Assets/images/accessories/SMF-17/SMF_17.svg",
    heroImage: "/Assets/images/accessories/SMF-17/SMF_17.svg",
    gallery: ["/Assets/images/accessories/SMF-17/SMF_17.svg"],
    productSheetPdf: "/Assets/images/accessories/SMF-17/SMF-17_PAF.pdf",
    description: "Mill-finished low-profile pre-drilled aluminum frame for secure surface-mounted applications. Wider profile improves coverage and hold.",
    features: ["Provides stable surface-mounted support", "Wider profile improves coverage and hold", "Fast, consistent installation"],
    specifications: { dimensions: "2.25\" W x 8' L x 0.438\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled, 10 holes", profile: "Low profile" }
  },
  // ==================== ACCESSORIES - SURFACE-MOUNTED ANCILLARIES ====================
  {
    id: 78,
    slug: "h-section-ancillary",
    name: "H-Section",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/H-Section/H-SEC.svg",
    heroImage: "/Assets/images/accessories/H-Section/H-SEC.svg",
    gallery: ["/Assets/images/accessories/H-Section/H-SEC.svg"],
    productSheetPdf: "/Assets/images/accessories/H-Section/SMA_H-SEC.pdf",
    description: "Aluminum divider with PVC insert for seamless front-to-back matting installations. Acts as an invisible divider between adjoining mat sections.",
    features: ["Acts as an invisible divider between adjoining mat sections", "Creates a clean continuous transition", "Maintains alignment"],
    specifications: { dimensions: "0.5\" W x 9' 10\" L x 0.4375\" H", material: "Aluminum with matching PVC insert", compatibility: "14mm / 10.5mm matting" }
  },
  {
    id: 79,
    slug: "u-section-ancillary",
    name: "U-Section",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/U-Section/U-SEC.svg",
    heroImage: "/Assets/images/accessories/U-Section/U-SEC.svg",
    gallery: ["/Assets/images/accessories/U-Section/U-SEC.svg"],
    productSheetPdf: "/Assets/images/accessories/U-Section/SMA_U-SEC.pdf",
    description: "Mill-finished aluminum section used as a front-to-back frame or divider for matting systems. Provides structural edge support.",
    features: ["Frames or divides matting sections front-to-back", "Provides structural edge support", "Helps contain and secure matting"],
    specifications: { dimensions: "0.75\" W x 9' 10\" L x 0.5625\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", compatibility: "14mm matting" }
  },
  {
    id: 80,
    slug: "t-section-ancillary",
    name: "T-Section",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/T-Section/T-SEC.svg",
    heroImage: "/Assets/images/accessories/T-Section/T-SEC.svg",
    gallery: ["/Assets/images/accessories/T-Section/T-SEC.svg"],
    productSheetPdf: "/Assets/images/accessories/T-Section/SMA_T-SEC.pdf",
    description: "Mill-finished aluminum divider for large left-to-right matting installations. Maintains alignment over larger spans.",
    features: ["Divides matting sections across wide layouts", "Maintains alignment over larger spans", "Provides structural separation"],
    specifications: { dimensions: "1.0625\" W x 9' 10\" L x 0.625\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", compatibility: "14mm matting" }
  },
  {
    id: 81,
    slug: "edge-r-ancillary",
    name: "Edge R",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/EDGE-R/Edge_R.svg",
    heroImage: "/Assets/images/accessories/EDGE-R/Edge_R.svg",
    gallery: ["/Assets/images/accessories/EDGE-R/Edge_R.svg"],
    productSheetPdf: "/Assets/images/accessories/EDGE-R/SMA_Edge-R.pdf",
    description: "Mill-finished aluminum edge cap for securing and finishing exposed matting ends. Creates a clean finished edge.",
    features: ["Caps and secures exposed matting edges", "Prevents movement at system boundaries", "Creates a clean finished edge"],
    specifications: { dimensions: "0.75\" W x 9' 10\" L x 0.5625\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", compatibility: "14mm matting" }
  },
  {
    id: 82,
    slug: "edge-z-ancillary",
    name: "Edge Z",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/EDGE-Z/Edge_Z.svg",
    heroImage: "/Assets/images/accessories/EDGE-Z/Edge_Z.svg",
    gallery: ["/Assets/images/accessories/EDGE-Z/Edge_Z.svg"],
    productSheetPdf: "/Assets/images/accessories/EDGE-Z/SMA_Edge-Z.pdf",
    description: "Mill-finished aluminum edge for finishing matting installations alongside ceramic tile. Aligns matting height with surrounding flooring.",
    features: ["Provides a clean transition between matting and ceramic tile", "Caps and secures exposed edges", "Aligns matting height with surrounding flooring"],
    specifications: { dimensions: "1.3125\" W x 12' L x 0.5\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", compatibility: "10.5mm matting, Adjacent to ceramic tile" }
  },
  {
    id: 83,
    slug: "tlp-section-ancillary",
    name: "TLP Section",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/TLP-Section/TLP-SEC.svg",
    heroImage: "/Assets/images/accessories/TLP-Section/TLP-SEC.svg",
    gallery: ["/Assets/images/accessories/TLP-Section/TLP-SEC.svg"],
    productSheetPdf: "/Assets/images/accessories/TLP-Section/SMA_TLP-SEC.pdf",
    description: "Mill-finished aluminum divider for large left-to-right installations of 10.5mm matting. Maintains alignment over larger spans.",
    features: ["Divides matting sections across wide layouts", "Maintains alignment over larger spans", "Provides structural separation"],
    specifications: { dimensions: "1.3125\" W x 8' L x 0.5\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", compatibility: "10.5mm matting" }
  },
  {
    id: 84,
    slug: "ulp-section-ancillary",
    name: "ULP Section – Low Profile",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/Low-Profile-ULP-Section/Edge_ULP.svg",
    heroImage: "/Assets/images/accessories/Low-Profile-ULP-Section/Edge_ULP.svg",
    gallery: ["/Assets/images/accessories/Low-Profile-ULP-Section/Edge_ULP.svg"],
    productSheetPdf: "/Assets/images/accessories/Low-Profile-ULP-Section/SMA_ULP-SEC.pdf",
    description: "Low-profile aluminum frame/divider for front-to-back installations of 10.5mm matting. Provides structural support with a low profile.",
    features: ["Frames or divides matting sections front-to-back", "Provides structural support with a low profile", "Helps secure and align matting"],
    specifications: { dimensions: "0.75\" W x 8' L x 0.4375\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", profile: "Low profile", compatibility: "10.5mm matting" }
  },
  {
    id: 85,
    slug: "edge-rlpx-ancillary",
    name: "Edge RLPX",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/EDGE-RLPX/edge-RLPX.svg",
    heroImage: "/Assets/images/accessories/EDGE-RLPX/edge-RLPX.svg",
    gallery: ["/Assets/images/accessories/EDGE-RLPX/edge-RLPX.svg"],
    productSheetPdf: "/Assets/images/accessories/EDGE-RLPX/SMA_Edge-RLPX.pdf",
    description: "Mill-finished aluminum transition edge for connecting 10.5mm matting to carpet tiles. Provides a smooth secure edge connection.",
    features: ["Transitions between matting and carpet tile", "Provides a smooth secure edge connection", "Aligns differing material heights"],
    specifications: { dimensions: "1.56\" W x 12' L x 0.5\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", compatibility: "10.5mm matting to carpet tile" }
  },
  {
    id: 86,
    slug: "edge-rlp-ancillary",
    name: "Low-Profile Edge RLP",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/Low-Profile-EDGE-RLP/edge-RLP.svg",
    heroImage: "/Assets/images/accessories/Low-Profile-EDGE-RLP/edge-RLP.svg",
    gallery: ["/Assets/images/accessories/Low-Profile-EDGE-RLP/edge-RLP.svg"],
    productSheetPdf: "/Assets/images/accessories/Low-Profile-EDGE-RLP/SMA_LP-Edge-RLP.pdf",
    description: "Mill-finished low-profile aluminum edge cap for securing and finishing matting ends. Maintains a low minimal edge profile.",
    features: ["Caps and secures exposed matting edges", "Maintains a low minimal edge profile", "Provides a clean finished perimeter"],
    specifications: { dimensions: "1\" W x 8' L x 0.50\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", profile: "Low-profile edge", compatibility: "14mm matting" }
  },
  {
    id: 87,
    slug: "edge-j-ancillary",
    name: "Edge J",
    variant: "Ancillary",
    category: "Accessories",
    categoryId: "accessories",
    accessoryType: "ancillary",
    image: "/Assets/images/accessories/EDGE-J/Edge_J.svg",
    heroImage: "/Assets/images/accessories/EDGE-J/Edge_J.svg",
    gallery: ["/Assets/images/accessories/EDGE-J/Edge_J.svg"],
    productSheetPdf: "/Assets/images/accessories/EDGE-J/SMA_Edge-J.pdf",
    description: "Mill-finished aluminum edge cap designed for terminating matting installations against walls. Creates a clean finished transition to vertical surfaces.",
    features: ["Caps and secures matting edges where they meet a wall", "Creates a clean finished transition to vertical surfaces", "Prevents edge movement at wall boundaries"],
    specifications: { dimensions: "1.5\" W x 10' L x 0.625\" H", material: "Aluminum, mill finish", drilling: "Pre-drilled", compatibility: "14mm matting" }
  }
];
